import { render, staticRenderFns } from "./AnalysisComponent.vue?vue&type=template&id=0bfcaf34&scoped=true&"
import script from "./AnalysisComponent.vue?vue&type=script&lang=ts&"
export * from "./AnalysisComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AnalysisComponent.vue?vue&type=style&index=0&id=0bfcaf34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfcaf34",
  null
  
)

export default component.exports